import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';
import {ControlItem, ControlName} from './ControlsComponents';

const FirstSection = props => {
  return (
    <View style={styles.row}>
      <View style={[styles.width5, styles.sectionHeader, styles.center]}>
        <Text style={[styles.text10, styles.rotated, {width: '250%'}]}>
          ÇDO MUAJ
        </Text>
      </View>
      <View style={[styles.flex1, styles.borderLeft]}>
        <View style={[styles.row]}>
          <ControlName text="Pastrimi" />
          <View style={[styles.flex1, styles.row]}>
            <ControlItem
              text="Pastrimi i pjesës së epërme dhe të poshtme të dhomës makinerike"
              selected={props.check1}
              style={[styles.flex1]}
            />
          </View>
        </View>
        <View style={[styles.row]}>
          <ControlName text="Distanca në mes shkelësve dhe anësoreve" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem text="Max 4mm" selected={props.check2} />
              <ControlItem
                text="Shuma e distancës e matur në të dyja anët e shkallës nuk duhet të kaloj 7mm"
                selected={props.check3}
                style={[styles.flex1]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check4}
              />
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <ControlName text="Paneli i krehërve" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                text="Nuk ka dhëmbë të thyer"
                style={[styles.flex1]}
                selected={props.check5}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Distanca në mes krehërve të shkallës dhe kanaleve të tyre (ku përshtatet shkelësja) të jetë minimum 6mm"
                style={[styles.flex1]}
                selected={props.check6}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check7}
              />
            </View>
          </View>
        </View>
        <View style={styles.row}>
          <ControlName text="Shkelëset (shkalla)" />
          <View style={styles.flex1}>
            <View style={styles.row}>
              <ControlItem
                selected={props.check8}
                style={[styles.flex1]}
                text="Nuk ka dhëmbë të thyer"
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Shkelësja nuk duhet të ketë tolerancë të lëvizjes anësore më shumë se 0.4mm, (lëvizja në boshtin e shkelëses në raport me shkelësin)"
                style={[styles.flex1]}
                selected={props.check9}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check10}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default FirstSection;
